import MonetizationOnIcon from "@material-ui/icons/MonetizationOn";
import EconomicSectorList from "./EconomicSectorList";

export default {
  list: EconomicSectorList,
  icon: MonetizationOnIcon,
};
